import React from 'react';
import styled from 'styled-components';
import { Icon, Card } from '@bb/elements-web';
import { TitleCircle } from '../../StyledComponents';
import PhoneBoxPopulated from '../../ManageListings/PhoneBoxPopulated';

/**
 * The card displaying the details about the user/brokerage's current Appointment Desk
 * subscription (if they have one) on the Learn More step of the subscription signup flow.
 */
const AppointmentDeskCard: React.FC = () => {
  const bulletItems = [
    'US and Canada-based live answering service',
    'Staffed by showing management specialists',
    'Handles incoming calls for your listings including appointment booking, showing requests',
  ];

  const cardTitle = (
    <TitleContainer>
      <TitleCircle>
        <Icon icon="appointmentDesk" color="primary" />
      </TitleCircle>
      <span>Appointment Desk</span> <ActivePill>Active</ActivePill>
    </TitleContainer>
  );

  return (
    <StyledCard title={cardTitle} $withContent={false} dataCy="appt-desk-card">
      <div>
        <PhoneBoxPopulated />
        <Divider />
        <BulletList>
          {bulletItems.map((item, index) => (
            <BulletItem key={index}>
              <Icon
                icon="checkOutlined"
                style={{ color: '#2c6ef2' }}
                size={16}
              />
              <span>{item}</span>
            </BulletItem>
          ))}
        </BulletList>
      </div>
    </StyledCard>
  );
};

export default AppointmentDeskCard;

const ActivePill = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(
    270deg,
    #77ffff -58.2%,
    #2c6ef2 62.35%,
    #274680 129.51%
  );
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  padding: 2px 12px;
  border-radius: 4px;
  white-space: nowrap;
`;

export const StyledCard = styled(Card)<{ $withContent?: boolean }>`
  width: 501px;

  .ant-card-head {
    border-bottom: 0px;
  }

  .ant-card-body {
    padding: 0px 24px 24px 24px;
  }

  ${({ $withContent }) =>
    $withContent &&
    `.ant-card-body {
      padding: 1px 0px;
    }`}
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 600;
`;

const Divider = styled.div`
  height: 1px;
  background-color: #e8e8e8;
  margin-top: 16px;
  margin-bottom: 16px;
`;

const BulletList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const BulletItem = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  font-size: 16px;
  color: #1a1b21;
`;
